import { Popover, PopoverOpenChangeDetails, Portal } from "@chakra-ui/react";
import { ReactNode } from "react";
import { LightMode } from "../ui/color-mode";

interface Props {
  open: boolean;
  onOpenChange: (details: PopoverOpenChangeDetails) => void;
  triggerComponent: ReactNode;
  bodyComponent: ReactNode;
}

export const CustomPopover = ({
  onOpenChange,
  open,
  triggerComponent,
  bodyComponent,
}: Props) => {
  return (
    <Popover.Root
      positioning={{ placement: "left-end" }}
      open={open}
      onOpenChange={onOpenChange}
    >
      <Popover.Arrow />
      <Popover.Trigger asChild>{triggerComponent}</Popover.Trigger>
      <Portal>
        <LightMode>
          <Popover.Positioner>
            <Popover.Content width="100%">
              <Popover.Arrow />
              <Popover.Body>{bodyComponent}</Popover.Body>
              <Popover.CloseTrigger />
            </Popover.Content>
          </Popover.Positioner>
        </LightMode>
      </Portal>
    </Popover.Root>
  );
};
